interface ItemProps {
  id: string
  sku: string | null
  nome: string
  tipo: 'EQUIPAMENTO' | 'PRODUTO' | 'SERVICO'
  qtd: number
  valorUnit: number
}

export class Item {
  constructor(private readonly props: ItemProps) {}

  get id() {
    return this.props.id
  }

  get sku() {
    return this.props.sku
  }

  get nome() {
    return this.props.nome
  }

  get tipo() {
    return this.props.tipo
  }

  get qtd() {
    return this.props.qtd
  }

  get valorUnit() {
    return Math.round(this.props.valorUnit * 100) / 100
  }

  get valorTotal() {
    return Math.round(this.qtd * this.valorUnit * 100) / 100
  }
}
